import React, { useState } from "react";
import { Tooltip } from "@mui/material";

const CustomTooltip = ({ title, children }) => {
  const [isTooltipOpen, setTooltipOpen] = useState(false);

  // Check if the device is a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const handleTooltipOpen = () => {
    if (isMobile) {
      setTooltipOpen(true);
    }
  };

  const handleTooltipClose = () => {
    if (isMobile) {
      setTooltipOpen(false);
    }
  };

  return (
    <Tooltip
      title={title}
      open={isTooltipOpen}
      onClose={handleTooltipClose}
      onMouseEnter={!isMobile ? () => setTooltipOpen(true) : undefined}
      onMouseLeave={!isMobile ? () => setTooltipOpen(false) : undefined}
      onClick={isMobile ? handleTooltipOpen : undefined}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;